import {
  GET_REFERRAL_LIST,
  GET_REFERRAL_LIST_FAILURE,
  GET_REFERRAL_LIST_SUCCESS,
  CHANGE_PUBLISH,
  CHANGE_PUBLISH_SUCCESS,
  CHANGE_PUBLISH_FAILURE,
  GET_REFERRAL_DETAIL,
  GET_REFERRAL_DETAIL_SUCCESS,
  GET_REFERRAL_DETAIL_FAILURE,
  REFERRAL_UPDATE,
  REFERRAL_UPDATE_SUCCESS,
  REFERRAL_UPDATE_FAILURE
} from './mutation-types'

export default {
  state: {
  },
  getters: {
  },
  actions: {
    [GET_REFERRAL_LIST] ({ dispatch, commit }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: '/master/referrals', data: params.data })
          .then(res => {
            if (res.status === 200 || res.status === 304) {
              if (res.data.error) {
                commit(GET_REFERRAL_LIST_FAILURE)
                reject(res.data.error)
              } else {
                commit(GET_REFERRAL_LIST_SUCCESS)
                resolve(res.data)
              }
            }
          })
          .catch(err => {
            commit(GET_REFERRAL_LIST_FAILURE)
            reject(err)
          })
      })
    },
    [CHANGE_PUBLISH] ({ dispatch, commit }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPatch', { url: '/master/referrals/change_publish', data: params.data })
          .then(res => {
            if (res.status === 200 || res.status === 304) {
              if (res.data.error) {
                commit(CHANGE_PUBLISH_FAILURE)
                reject(res.data.error)
              } else {
                commit(CHANGE_PUBLISH_SUCCESS)
                resolve(res.data)
              }
            }
          })
          .catch(err => {
            commit(CHANGE_PUBLISH_FAILURE)
            reject(err)
          })
      })
    },
    [GET_REFERRAL_DETAIL] ({ dispatch, commit }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: `/master/referrals/${params['data'].id}/edit`, data: params.data })
          .then(res => {
            if (res.status === 200 || res.status === 304) {
              if (res.data.error) {
                commit(GET_REFERRAL_DETAIL_FAILURE)
                reject(res.data.error)
              } else {
                commit(GET_REFERRAL_DETAIL_SUCCESS)
                resolve(res.data)
              }
            }
          })
          .catch(err => {
            commit(GET_REFERRAL_DETAIL_FAILURE)
            reject(err)
          })
      })
    },
    [REFERRAL_UPDATE] ({ dispatch, commit }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPatch', { url: `/master/referrals/${params['data'].referral_id}`, data: params.data })
          .then(res => {
            if (res.status === 200 || res.status === 304) {
              if (res.data.error) {
                commit(REFERRAL_UPDATE_FAILURE)
                reject(res.data.error)
              } else {
                commit(REFERRAL_UPDATE_SUCCESS, { callback: params.callback })
                resolve(res.data)
              }
            }
          })
          .catch(err => {
            commit(REFERRAL_UPDATE_FAILURE)
            reject(err)
          })
      })
    }
  },
  mutations: {
    [GET_REFERRAL_LIST_FAILURE] () {
      console.log('GET_REFERRAL_LIST_FAILURE')
    },
    [GET_REFERRAL_LIST_SUCCESS] (state, data) {
      console.log('GET_REFERRAL_LIST_SUCCESS')
    },
    [CHANGE_PUBLISH_FAILURE] () {
      console.log('CHANGE_PUBLISH_FAILURE')
    },
    [CHANGE_PUBLISH_SUCCESS] () {
      console.log('CHANGE_PUBLISH_SUCCESS')
    },
    [GET_REFERRAL_DETAIL_FAILURE] () {
      console.log('GET_REFERRAL_DETAIL_FAILURE')
    },
    [GET_REFERRAL_DETAIL_SUCCESS] () {
      console.log('GET_REFERRAL_DETAIL_SUCCESS')
    },
    [REFERRAL_UPDATE_FAILURE] () {
      console.log('GET_REFERRAL_DETAIL_FAILURE')
    },
    [REFERRAL_UPDATE_SUCCESS] (state, date) {
      console.log('GET_REFERRAL_DETAIL_SUCCESS')
      if (date.callback) {
        date.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/referral.js